


// document.dispatchEvent(new CustomEvent('quantity:updated', {detail: {value: this.inputElement.value}}));
document.addEventListener('quantity:updated', function(event) {
	//console.log("quantity:updated = " + event.detail.value);
  	var new_qty = parseInt(event.detail.value);
  
    
  	var allQty = document.getElementsByName("quantity");
    var eleQty = allQty[allQty.length - 1];
  	//console.log("quantity:updated = " + new_qty + ", allQty max = " + max);
  	if(eleQty.max && eleQty.max != "" && new_qty > eleQty.max) {
        eleQty.value = eleQty.max;
        new_qty = eleQty.max;
    }

    
	var allSelect = document.getElementsByClassName('product-form__single-selector');
  	if(allSelect.length > 0) {
    	var select = allSelect[0];
      
      	//console.log("new_qty = " + new_qty + ", local max = " + allSelect[0].options[0].getAttribute("data-max"));
        if(new_qty <= parseInt(allSelect[0].options[0].getAttribute("data-max"))) {
          select.options[0].selected = "selected";
        } else {
          select.options[1].selected = "selected";        
        }
        //console.log("variant sel = " + (select.options[0].selected == "selected" ? "local" : "overseas"));
      
        // Fire change event
        var evt = document.createEvent("HTMLEvents");
        evt.initEvent("change", true, true);
        select.dispatchEvent(evt);
    }
});

document.addEventListener('product:added', function(event) {
    //var variant = event.detail.variant; // Get the variant that was added
    var quantity = event.detail.quantity; // Get the quantity that was added
  
    
  	var allQty = document.getElementsByName("quantity");
    var eleQty = allQty[allQty.length - 1];
  	if(eleQty.max && eleQty.max != "") {
      eleQty.max -= quantity;
      
      if(eleQty.max <= 0) {
          document.getElementsByClassName('product-form__info-list')[0].style.display = 'none';
          document.getElementsByClassName('product-form__payment-container')[0].style.display = 'none';
          document.getElementById("msg-quantity-limit").innerHTML += "<br>Already in cart";
      } else {
        /*document.getElementsByClassName('product-form__info-list')[0].style.display = 'block';
        document.getElementsByClassName('product-form__payment-container')[0].style.display = '';
        document.getElementById("msg-quantity-limit").innerHTML = document.getElementById("msg-quantity-limit").innerHTML.replace("<br>Already in cart", "");*/
        eleQty.value = "1";
      }
    }
});



function npa_request(product_id, variant_id) {
	var input = document.getElementById('npa-email');
	if (input.value == "") {
		document.getElementsByClassName("npa-msg-fail2")[0].style.display = "block";
	} else {

		if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(input.value) == false) {
			document.getElementsByClassName("npa-msg-fail2")[0].style.display = "block";
			return;
		}

		input.className += " disabled";
		input.disabled = true;

		var btn = document.getElementById("npa-btn");
		btn.value = "Processing";
		btn.disabled = "disabled";
		btn.className += " disabled";

		var req_data = "request=npa&req_data=" + product_id + "&req_email=" + input.value;
		var http = new XMLHttpRequest();
		http.open("GET", "https://message.apptronix.com.au/get_info.php?" + req_data);
		http.onreadystatechange = function() {
			if(http.readyState == 4 && http.status == 200) {
				var data = JSON.parse(http.responseText.replace("npa_result(", "").replace(")",""));

				document.getElementById("div_npa").style.display = "none";
				document.getElementsByClassName("npa-msg-fail2")[0].style.display = "none";
				if (data.r == 1) {
					document.getElementsByClassName("npa-msg-success")[0].style.display = "block";
				} else {
					document.getElementsByClassName("npa-msg-fail")[0].style.display = "block";
				}
			}
		};
		http.send(null);
	}
}
function npa_result(data) {    
	document.getElementById("div_npa").style.display = "none";
	if (data.r == 1) {
		document.getElementsByClassName("npa-msg-success")[0].style.display = "block";
	} else {
		document.getElementsByClassName("npa-msg-fail")[0].style.display = "block";
	}
}




function pricematch_request(product_id) {
	var input = document.getElementById('pricematch-email');
    var input_name = document.getElementById('pricematch-name');
    var input_link = document.getElementById('pricematch-link');
    var input_price = document.getElementById('pricematch-price');
	if (input.value == "" || input_name == "" || input_link.value == "" || input_price.value == "") {
		document.getElementsByClassName("pricematch-msg-fail2")[0].style.display = "block";
	} else {

		if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(input.value) == false) {
			document.getElementsByClassName("pricematch-msg-fail2")[0].style.display = "block";
			return;
		}

		input.className += " disabled";
		input.disabled = true;

		var btn = document.getElementById("pricematch-btn");
		btn.value = "Processing";
		btn.disabled = "disabled";
		btn.className += " disabled";

		var req_data = "request=pricematch&req_data=" + product_id + "&req_email=" + input.value + "&req_name=" + input_name.value + "&req_link=" + input_link.value + "&req_price=" + input_price.value;
		var http = new XMLHttpRequest();
		http.open("GET", "https://message.apptronix.com.au/get_info.php?" + req_data);
		http.onreadystatechange = function() {
			if(http.readyState == 4 && http.status == 200) {
				var data = JSON.parse(http.responseText.replace("pricematch_result(", "").replace(")",""));

				//document.getElementById("div_npa").style.display = "none";
				document.getElementsByClassName("pricematch-msg-fail2")[0].style.display = "none";
				if (data.r == 1) {
					document.getElementsByClassName("pricematch-msg-success")[0].style.display = "block";

                    setTimeout(function(){
                        var dom = document.getElementById('price-match-popover');
                        dom.ariaHidden='true';  
                    }, 1500);
                    
				} else {
					document.getElementsByClassName("pricematch-msg-fail")[0].style.display = "block";
				}
			}
		};
		http.send(null);
	}
}
function pricematch_result(data) {    
	document.getElementById("div_npa").style.display = "none";
	if (data.r == 1) {
		document.getElementsByClassName("npa-msg-success")[0].style.display = "block";
	} else {
		document.getElementsByClassName("npa-msg-fail")[0].style.display = "block";
	}
}





function genquote_request() {
    //var cust = PAKR_cust;
    if(pre_validate()) {

        var btn = document.getElementById("genquote-btn");
		btn.textContent = "Processing";
		btn.disabled = "disabled";
		btn.className += " disabled";
      
        
        fetch("/cart.js", {
          credentials: 'same-origin',
          method: 'GET',
          headers: {
            'Cache-Control': 'no-cache'
          }
        }).then(function (content) {
            content.json().then(function (content) {
                var req_data = "request=genquote&req_data=0&req_cart=" + content['token'] + "&req_cust=" + PAKR_cust;
        		var http = new XMLHttpRequest();
        		http.open("GET", "https://message.apptronix.com.au/get_info.php?" + req_data);
        		http.onreadystatechange = function() {
        			if(http.readyState == 4 && http.status == 200) {
        				var data = JSON.parse(http.responseText.replace("genquote_result(", "").replace(")",""));
        				//console.log("genquote_request status res = " + data.r);  
        				
        				//document.getElementsByClassName("pricematch-msg-fail2")[0].style.display = "none";
        				if (data.r == 1) {
                            var btn = document.getElementById("genquote-btn");
                    		btn.textContent = "Quote Requested";
                          
                            alert("Thank you. We have received your request and will get back to you within 1 business day.");
                          
        					/*document.getElementsByClassName("pricematch-msg-success")[0].style.display = "block";
        
                            setTimeout(function(){
                                var dom = document.getElementById('price-match-popover');
                                dom.ariaHidden='true';  
                            }, 1500);
                            */
        				} else {
                            alert("Error: cannot send request. Please try again");
        					//document.getElementsByClassName("pricematch-msg-fail")[0].style.display = "block";
        				}
        			}
        		};
        		http.send(null);
            });
        });
	}
}

